import { ReactNode, useEffect, useState } from 'react';
import { Header } from '../organisms/Header';
import { Sidebar } from '../organisms/Sidebar';

export function AppShell({ children }: { children: ReactNode }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    if (!isMenuOpen) return;

    const previousOverflow = document.body.style.overflow;
    const closeOnEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') setIsMenuOpen(false);
    };

    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', closeOnEscape);

    return () => {
      document.body.style.overflow = previousOverflow;
      document.removeEventListener('keydown', closeOnEscape);
    };
  }, [isMenuOpen]);

  return (
    <div className="app-shell">
      <Sidebar isOpen={isMenuOpen} onClose={() => setIsMenuOpen(false)} />
      {isMenuOpen && (
        <button
          aria-label="Close navigation menu"
          className="sidebar-backdrop"
          type="button"
          onClick={() => setIsMenuOpen(false)}
        />
      )}
      <div className="app-main">
        <Header isMenuOpen={isMenuOpen} onMenuOpen={() => setIsMenuOpen(true)} />
        <main className="page-content">{children}</main>
      </div>
    </div>
  );
}
